import {
  BreakpointQueryName,
  ThemedFunctor,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const jobsList: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[75]};
  margin-top: ${theme.remSize[150]};
`;

export const divider: ThemedFunctor = ({ theme }) => css`
  background: ${theme.color.border.neutral.default.high};
  height: 1px;
`;

export const jobItem: ThemedFunctor = ({ theme }) => css`
  align-items: center;
  display: flex;
  gap: ${theme.remSize[75]};
`;

export const spinnerWrapper: ThemedFunctor = () => css`
  width: 20px;
`;

export const jobTitleWrapper: ThemedFunctor = () => css`
  flex: 1 0 0;
  min-width: 0;
  overflow: hidden;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const popoverContent: ThemedFunctor = ({ theme }) => css`
  width: calc(100vw - ${theme.remSize[400]});

  ${theme.breakpoints.up(BreakpointQueryName.SM)} {
    max-width: 24rem;
  }
`;
